import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "campaign-analytics/:id",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const campaignDetailsV2 = require("./CampaignReports").default;
          cb(null, campaignDetailsV2);
        },
        "campaignReport"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/CampaignReports/index.js